import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex flex-col items-center justify-center bg-background-50 px-4 py-24 text-center md:py-32">
      <p className="font-display text-8xl font-black text-background-200 select-none md:text-[10rem]">404</p>
      <h1 className="mt-4 font-display text-2xl font-bold text-foreground-950">这片瓜田走岔了</h1>
      <p className="mt-3 text-foreground-600">
        你访问的地址不存在：<span className="rounded bg-background-100 px-2 py-0.5 font-mono text-sm text-foreground-500">{location.pathname}</span>
      </p>
      <p className="mt-1 text-sm text-foreground-500">内容可能已被移动或删除，换个地方逛逛吧。</p>
      <div className="mt-8 flex flex-wrap items-center gap-3">
        <Link to="/" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600">
          <i className="ri-home-4-line" aria-hidden="true"></i>
          回到首页
        </Link>
        <Link to="/rexun" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700">
          去看看瓜田热闻
        </Link>
      </div>
    </div>
  );
}